import React, { PureComponent } from 'react'
import numeral from 'numeral'
import { Query } from 'react-apollo'
import ReactTable from 'react-table'
import _ from 'lodash'
import {
 Checkbox, Icon as AntIcon, AutoComplete, Select,
} from 'antd'
import { Icon, Div, P } from 'konsys-ui'
import moment from 'moment'
import { ChevronsUp, ChevronsUpDown } from 'lucide-react'
import { JOB_LIST, GET_CLIENTS } from '../../../constants/graphql/query'
import {
  InputWithPlaceHolder, StatusSelector, ActionSelectors, HeaderLabel, CellText,
} from '../../../components/invoice-components'
import { theme } from '../../../styles/_variables'
import { status, statusText } from '../constants'

const { color } = theme

export default class Table extends PureComponent {
  constructor() {
    super()
    this.state = { number: undefined }
  }

  array = [{
    accessor: 'checkbox',
    filterable: true,
    sortable: false,
    Cell: props => (
        <Checkbox
          disabled={props.tdProps.rest.checkDisabled}
          key={props.value}
          checked={_.includes(props.tdProps.rest.check, props.original.id)}
          onChange={(e) => {
            if (e.target.checked) {
              props.tdProps.rest.setCheck(_.concat(props.tdProps.rest.check, props.original.id))
              props.tdProps.rest.setInvoices(_.concat(props.tdProps.rest.invoices, props.original))
            } else {
              props.tdProps.rest.setCheck(_.remove(_.cloneDeep(props.tdProps.rest.check), n => n !== props.original.id))
              props.tdProps.rest.setInvoices(_.remove(_.cloneDeep(props.tdProps.rest.invoices), n => n.id !== props.original.id))
            }
          }}
        />
    ),
    width: 80,
    Filter: props => (
        <Div display='flex' justifyContent='space-between' alignItems='flex-start'>
          <Checkbox
            style={{ paddingLeft: 3 }}
            checked={this.props.isCheckAll}
            disabled={this.props.checkDisabled}
            onChange={e => props.onChange(e)}
          />
        </Div>
    ),
  }, {
    Header: () => (
        <Div display='flex' justifyContent='space-between' alignItems='center'>
          <HeaderLabel>
            ใบวางบิล / ใบแจ้งหนี้ <ChevronsUpDown color={color.coolGrey} />
          </HeaderLabel>
        </Div>
    ),
    accessor: 'refId',
    sortable: true,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 150,
  }, {
    Header: () => (
          <HeaderLabel>
            Customer Ref Id
          </HeaderLabel>
    ),
    accessor: 'customerRefId',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
    width: 180,
  },
  // {
  //   Header: () => (
  //       <Div display='flex' justifyContent='space-between' alignItems='center'>
  //         <HeaderLabel>
  //           เล่มที่ <ChevronsUpDown color={color.coolGrey} />
  //         </HeaderLabel>
  //       </Div>
  //   ),
  //   accessor: 'volume',
  //   Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
  //   Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  //   filterMethod: (filter, row) => _.includes(row.fullname, filter.value),
  //   sortable: true,
  //   filterable: true,
  //   width: 100,
  // }, {
  //   Header: () => (
  //       <Div display='flex' justifyContent='space-between' alignItems='center'>
  //         <HeaderLabel>
  //           เลขที่ <ChevronsUpDown color={color.coolGrey} />
  //         </HeaderLabel>
  //       </Div>
  //   ),
  //   accessor: 'number',
  //   sortable: true,
  //   filterable: true,
  //   Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
  //   Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
  //   filterMethod: (filter, row) => _.includes(row.employeeId, filter.value),
  //   width: 100,
  // },
  {
    Header: () => (
        <Div display='flex' justifyContent='space-between' alignItems='center'>
          <HeaderLabel>
            วันที่วางบิล <ChevronsUpDown color={color.coolGrey} />
          </HeaderLabel>
        </Div>
    ),
    accessor: 'createdDate',
    sortable: true,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value ? moment(props.value).format('DD/MM/YY') : '' }</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 120,
  }, {
    Header: () => (
        <Div display='flex' justifyContent='space-between' alignItems='center'>
          <HeaderLabel>
            วันกำหนดชำระเงิน <ChevronsUpDown color={color.coolGrey} />
          </HeaderLabel>
        </Div>
    ),
    accessor: 'dueDate',
    sortable: true,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{props.value ? moment(props.value).format('DD/MM/YY') : '' }</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientId, filter.value),
    width: 120,
  }, {
    Header: () => <HeaderLabel>จำนวนเงิน</HeaderLabel>,
    accessor: 'shippingGrandTotal',
    sortable: false,
    filterable: false,
    Cell: props => <CellText textAlign='center'>{numeral(props.value).format('0,0.00')}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.remainTickets, filter.value),
    width: 150,
  }, {
    Header: () => <HeaderLabel>เลขสัญญางาน</HeaderLabel>,
    accessor: 'Job.number',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => (
      <Query
        query={JOB_LIST}
        variables={{
          number: this.state.number,
        }}
        fetchPolicy='cache-and-network'
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <AntIcon type="loading" spin />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <AutoComplete
            allowClear={true}
            dataSource={_.uniq(data.JobList.lists.map(v => v.number))}
            onSelect={(e) => {
              onChange(e)
            }}
            onChange={(e) => {
              if (!e) onChange(e)
            }}
            onSearch={e => this.setState({ number: e })}
            placeholder="ค้นหา"
          />
        )
      }}
      </Query>
    ),
    filterMethod: (filter, row) => _.includes(row.remainTickets, filter.value),
    width: 150,
  }, {
    Header: () => <HeaderLabel>ชื่อลูกค้า</HeaderLabel>,
    accessor: 'Job.Customer.companyName',
    sortable: false,
    filterable: true,
    Cell: props => <CellText textAlign='center'>{props.value}</CellText>,
    Filter: ({ onChange }) => (
      <Query
        query={GET_CLIENTS}
        variables={{
          companyName: this.state.companyName,
        }}
        fetchPolicy='cache-and-network'
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <AntIcon type="loading" spin />
        if (error) return <P>เกิดข้อผิดพลาด</P>
        return (
          <AutoComplete
            style={{ width: '100%' }}
            dataSource={_.uniq(data.getCustomerLists.lists.map(v => v.companyName))}
            onSelect={(e) => {
              onChange(_.find(data.getCustomerLists.lists, o => o.companyName === e)?.id)
            }}
            onSearch={e => this.setState({ companyName: e })}
            placeholder="ค้นหา"
          />
        )
      }}
      </Query>
    ),
    filterMethod: (filter, row) => _.includes(row.remainTickets, filter.value),
    width: 300,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => (
        <P bold color={
          props.value === status.OVERDUE
            ? color.error
            : props.value === status.WAITING
              ? color.warning
              : props.value === status.PAID
                ? color.success
                : props.value === status.BILLED
                  ? color.info
                  : props.value === status.PARTIAL
                    ? color.violet
                    : color.error
          }
        >
        {
          props.value === status.WAITING
            ? statusText.WAITING
            : props.value === status.OVERDUE
              ? statusText.OVERDUE
              : props.value === status.PAID
                ? statusText.PAID
                : props.value === status.BILLED
                  ? statusText.BILLED
                  : props.value === status.PARTIAL
                    ? statusText.PARTIAL
                    : statusText.CANCELLED
        }
        </P>
    ),
    filterMethod: (filter, row) => filter.value === row.status || filter.value === 'ALL',
    Filter: ({ onChange }) => <StatusSelector key='filter' statusAttr='ทั้งหมด' handleChange={e => onChange(e)} filter={true} />,
    width: 170,
  }, {
    Header: <HeaderLabel>สถานะ Peak</HeaderLabel>,
    accessor: 'peakSynced',
    sortable: false,
    filterable: true,
    Cell: props => (
      <P bold color={props.value ? color.success : color.error}>
        {props.value ? 'Sync แล้ว' : 'ยังไม่ Sync'}
      </P>
    ),
    filterMethod: (filter, row) => filter.value === row.peakSynced || filter.value === 'ALL',
    Filter: ({ onChange }) => (
      <Select
        dropdown
        style={{ width: 130 }}
        defaultValue="ทั้งหมด"
        onChange={e => onChange(e)}
      >
        {
          [
            { value: undefined, text: 'ทั้งหมด' },
            { value: true, text: 'Sync แล้ว' },
            { value: false, text: 'ยังไม่ Sync' },
          ].map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
        }
      </Select>
    ),
    width: 170,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelectors refetch={() => props.tdProps.rest.refetch()} props={props} />,
    width: 150,
  }]

  render() {
    const {
      data, current, setCurrent, refetch, check, setCheck, invoices, setInvoices, setFiltered, setSorted, checkDisabled,
    } = this.props
    return (
      <Div>
        <ReactTable
          className='table'
          data={data.InvoiceList.lists} // *
          resizable={false}
          columns={this.array} // *
          minRows={5}
          row={data.InvoiceList.lists.length}
          manual
          showPageSizeOptions={false}
          getTdProps={() => ({
            disabled: true, refetch, check, setCheck, checkDisabled, invoices, setInvoices,
          })} // *
          getTrProps={(state, rowInfo) => { // *
            if (rowInfo) {
              return {
                style: {
                  padding: '8px 0',
                  backgroundColor: '#ffffff',
                  borderLeft: rowInfo.original.status === status.WAITING
                    ? `3px solid ${color.warning}`
                    : rowInfo.original.status === status.OVERDUE
                      ? `3px solid ${color.error}`
                      : rowInfo.original.status === status.BILLED
                        ? `3px solid ${color.info}`
                        : `3px solid ${color.success}`,
                },
              }
            } return {}
          }}
          previousText='ก่อนหน้า'
          nextText='ถัดไป'
          pageText='หน้า'
          ofText='จาก'
          noDataText='ไม่พบข้อมูล'
          page={current}
          pages={Math.ceil(data.InvoiceList.totalFilter / 20)}
          onPageChange={page => setCurrent(page)}
          onFilteredChange={async (newFiltered, info) => {
            if (info.id === 'checkbox') {
              const currentList = data.InvoiceList.lists
              if (_.find(newFiltered, v => v.id === 'checkbox').value.target.checked) {
                setCheck(_.concat(currentList.map(v => v.id), _.remove(_.cloneDeep(check), o => !_.includes(currentList.map(v => v.id), o))))
                setInvoices(_.concat(currentList, _.remove(_.cloneDeep(invoices), o => !_.includes(currentList.map(v => v.id), o.id))))
              } else {
                setCheck(_.remove(_.cloneDeep(check), o => !_.includes(currentList.map(v => v.id), o)))
                setInvoices(_.remove(_.cloneDeep(currentList), o => !_.includes(currentList.map(v => v.id), o.id)))
              }
            } else {
              const newOjb = {}
              await newFiltered.forEach((v) => {
                if (v.id === 'id' || v.id === 'volume' || v.id === 'number') {
                  Object.assign(newOjb, { [v.id]: parseInt(v.value, 10) })
                } else if (v.id === 'Job.jobCode') {
                  Object.assign(newOjb, { jobCode: v.value })
                } else if (v.id === 'Job.number') {
                  Object.assign(newOjb, { jobNumber: v.value })
                } else if (v.id === 'Job.Customer.companyName') {
                  Object.assign(newOjb, { customerId: v.value })
                } else {
                  Object.assign(newOjb, { [v.id]: v.value })
                }
              })
              setFiltered(newOjb)
              setCurrent(0)
            }
          }}
          onSortedChange={async (newSorted) => {
            setSorted(newSorted)
            setCurrent(0)
          }}
        />
      </Div>
    )
  }
}
